// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` 

#msform fieldset{
  display: none;
}
#msform fieldset.active{
  display: block;
}
 
 #msform .action-button[disabled]{
  background-color : #616161 
}

.rdt_Pagination select{
  background-color: #212336;
}

/* Dark theme styles for SweetAlert confirmation popups */
.swal2-dark-theme {
  background-color: #2a2a2a !important;
  color: #ffffff !important;
  border: 1px solid #404040 !important;
}

.swal2-title-dark {
  color: #ffffff !important;
}

.swal2-content-dark {
  color: #e0e0e0 !important;
}

.swal2-confirm-dark {
  background-color: #198754 !important;
  border-color: #198754 !important;
  color: #ffffff !important;
}

.swal2-confirm-dark:hover {
  background-color: #157347 !important;
  border-color: #157347 !important;
}

.swal2-cancel-dark {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #ffffff !important;
}

.swal2-cancel-dark:hover {
  background-color: #5a6268 !important;
  border-color: #5a6268 !important;
}

/* Light theme styles for SweetAlert confirmation popups */
.swal2-light-theme {
  background-color: #ffffff !important;
  color: #333333 !important;
  border: 1px solid #dee2e6 !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.swal2-title-light {
  color: #333333 !important;
}

.swal2-content-light {
  color: #6c757d !important;
}

.swal2-confirm-light {
  background-color: #198754 !important;
  border-color: #198754 !important;
  color: #ffffff !important;
}

.swal2-confirm-light:hover {
  background-color: #157347 !important;
  border-color: #157347 !important;
}

.swal2-cancel-light {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #ffffff !important;
}

.swal2-cancel-light:hover {
  background-color: #5a6268 !important;
  border-color: #5a6268 !important;
}


.persona-wrapper {
    padding: 30px;
    color: #fff;
    font-family: sans-serif;
}

.header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.clear-btn {
    background: transparent;
    color: #00e1b4;
    border: none;
    cursor: pointer;
    font-size: 14px;
}

.persona-grid {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 20px;
}

.persona-card {
    background: #111;
    border: 1px solid #222;
    border-radius: 10px;
    padding: 18px;
    position: relative;
    cursor: pointer;
    transition: 0.2s;
}

.persona-card:hover {
    border-color: #444;
}

.persona-card.selected {
    border: 2px solid #00e1b4; /* Green Highlight */
    background: #073a33;
}

.icon-box {
    width: 45px;
    height: 45px;
    background: #1a1a1a;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
}

.emoji {
    font-size: 24px;
}

.tick-mark {
    position: absolute;
    top: 15px;
    right: 15px;
    background: #00e1b4;
    color: #000;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

/*  */

.persona-top-bar {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    margin-bottom: 20px;
}

.clear-btn {
    background: transparent;
    color: #00e6b0;
    border: none;
    cursor: pointer;
}

.add-custom-btn {
    background: #0a7b5f;
    padding: 8px 14px;
    border-radius: 6px;
    border: none;
    color: #fff;
    cursor: pointer;
}

.row-grid {
    display: flex;
    gap: 18px;
    margin-bottom: 20px;
}

.persona-card {
    width: 260px;
    background: #111;
    padding: 18px;
    border-radius: 12px;
    border: 1px solid #222;
    cursor: pointer;
    position: relative;
}

.persona-card:hover {
    border-color: #00e6b0;
}

.selected {
    border-color: #00e6b0;
    background: #082b24;
}

.tick {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #00e6b0;
    width: 22px;
    height: 22px;
    color: black;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.icon-box {
    width: 45px;
    height: 45px;
    background: #1c1c1c;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.more-box {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.error-text {
    color: red;
    margin-top: -10px;
    margin-bottom: 15px;
}

.submit-btn {
    background: #0f9f75;
    padding: 12px 22px;
    border-radius: 8px;
    color: white;
    border: none;
    margin-top: 14px;
}

.sidebar-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: flex-end;
}

.sidebar-panel {
    width: 400px;
    background: #111;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
}

.sidebar-card {
    background: #1a1a1a;
    border: 1px solid #222;
    padding: 12px;
    border-radius: 10px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
}

.sidebar-selected {
    border-color: #00e6b0;
    background: #083329;
}

.side-tick {
    background: #00e6b0;
    color: black;
    padding: 4px 8px;
    border-radius: 50%;
    margin-left: auto;
}


/* Sidebar Header */
.sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 1px solid #222;
    margin-bottom: 15px;
}

.sidebar-header .left-section h3 {
    font-size: 20px;
    margin: 0;
    color: #fff;
    font-weight: 600;
}

.sub-text {
    margin: 0;
    font-size: 12px;
    color: #aaaaaa;
}

/* Right buttons container */
.right-section {
    display: flex;
    align-items: center;
    gap: 10px;
}

/* Add Persona Button */
.add-btn {
    background: #0f9f75;
    color: white;
    padding: 8px 14px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-size: 13px;
}

.add-btn:hover {
    background: #0c7f5c;
}

/* Clean Close Button */
.close-btn {
    background: #1b1b1b;
    border: 1px solid #333;
    color: #fff;
    font-size: 14px;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.2s;
}

.close-btn:hover {
    background: #333;
}

.jc-create-wrapper {
    position: relative;
    display: inline-block;
    z-index: 999999;
}

/* Button */
.jc-create-btn {
    background-color: #0066ff;
    color: #fff;
    border: none;
    padding: 10px 18px;
    border-radius: 6px;
}
/* ///////////////// */

/* MAIN WRAPPER */
.consent-box-wrapper {
    color: #fff;
    font-family: Inter, sans-serif;
}

/* TOP CARD */
.consent-top-card {
    background: #101823;
    border: 1px solid #243043;
    padding: 18px;
    border-radius: 10px;
}

/* CONSENT COUNT BOXES */
.consent-count-box {
    padding: 10px 18px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: 0.2s;
}

.jc-create-btn:hover {
    background-color: #0050d1;
}

/* Dropdown */
.jc-dropdown-box {
    position: absolute;
    /* top: 8; */
    right: 0;
    width: 190px;
    /* background: #fff; */
    border-radius: 8px;
    /* box-shadow: 0px 4px 20px rgba(0, 0, 0, 30); */
    padding: 8px 0;
    z-index: 999999 !important;
    animation: jcFadeIn 0.15s ease-in-out;
    margin-right: 5px;
    margin-top: 5px;
    border: 1px solid #474849;
}

/* Items */
.jc-dropdown-item {
    padding: 10px 15px;
    font-size: 14px;
    cursor: pointer;
    transition: 0.15s;
    border-radius: 7px;
}

.jc-dropdown-item:hover {
    background: #eef2ff;
    color: #000;
}


/* Fade Animation */
/* @keyframes jcFadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
    gap: 6px;
} */

/* With Consent */
.consent-green {
    background: #0e3b2e;
    color: #2fe79c;
    border: 1px solid #2fe79c55;
}

/* Pending Consent */
.consent-yellow {
    background: #3e361f;
    color: #ffcf43;
    border: 1px solid #ffcf4355;
}

/* WARNING BOX */
.consent-warning-box {
    background: #2d2619;
    border: 1px solid #594a2f;
    padding: 14px;
    border-radius: 10px;
    color: #ffd87b;
    font-size: 14px;
}

#CreateAgentDropdown {
    background-color: #0d0f1c;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;CAEC;EACC;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,0DAA0D;AAC1D;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,oBAAoB;IAC/C,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,KAAK;;AAEL;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;AACA,sBAAsB;;AAEtB,iBAAiB;AACjB;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA,aAAa;AACb;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,cAAc;IACd,0BAA0B;IAC1B,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;;AAGA,mBAAmB;AACnB;;;;GAIG;;AAEH,iBAAiB;AACjB;IACI,mBAAmB;IACnB,cAAc;IACd,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,cAAc;IACd,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[" \n\n#msform fieldset{\n  display: none;\n}\n#msform fieldset.active{\n  display: block;\n}\n \n #msform .action-button[disabled]{\n  background-color : #616161 \n}\n\n.rdt_Pagination select{\n  background-color: #212336;\n}\n\n/* Dark theme styles for SweetAlert confirmation popups */\n.swal2-dark-theme {\n  background-color: #2a2a2a !important;\n  color: #ffffff !important;\n  border: 1px solid #404040 !important;\n}\n\n.swal2-title-dark {\n  color: #ffffff !important;\n}\n\n.swal2-content-dark {\n  color: #e0e0e0 !important;\n}\n\n.swal2-confirm-dark {\n  background-color: #198754 !important;\n  border-color: #198754 !important;\n  color: #ffffff !important;\n}\n\n.swal2-confirm-dark:hover {\n  background-color: #157347 !important;\n  border-color: #157347 !important;\n}\n\n.swal2-cancel-dark {\n  background-color: #6c757d !important;\n  border-color: #6c757d !important;\n  color: #ffffff !important;\n}\n\n.swal2-cancel-dark:hover {\n  background-color: #5a6268 !important;\n  border-color: #5a6268 !important;\n}\n\n/* Light theme styles for SweetAlert confirmation popups */\n.swal2-light-theme {\n  background-color: #ffffff !important;\n  color: #333333 !important;\n  border: 1px solid #dee2e6 !important;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.swal2-title-light {\n  color: #333333 !important;\n}\n\n.swal2-content-light {\n  color: #6c757d !important;\n}\n\n.swal2-confirm-light {\n  background-color: #198754 !important;\n  border-color: #198754 !important;\n  color: #ffffff !important;\n}\n\n.swal2-confirm-light:hover {\n  background-color: #157347 !important;\n  border-color: #157347 !important;\n}\n\n.swal2-cancel-light {\n  background-color: #6c757d !important;\n  border-color: #6c757d !important;\n  color: #ffffff !important;\n}\n\n.swal2-cancel-light:hover {\n  background-color: #5a6268 !important;\n  border-color: #5a6268 !important;\n}\n\n\n.persona-wrapper {\n    padding: 30px;\n    color: #fff;\n    font-family: sans-serif;\n}\n\n.header-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.clear-btn {\n    background: transparent;\n    color: #00e1b4;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.persona-grid {\n    margin-top: 20px;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 20px;\n}\n\n.persona-card {\n    background: #111;\n    border: 1px solid #222;\n    border-radius: 10px;\n    padding: 18px;\n    position: relative;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.persona-card:hover {\n    border-color: #444;\n}\n\n.persona-card.selected {\n    border: 2px solid #00e1b4; /* Green Highlight */\n    background: #073a33;\n}\n\n.icon-box {\n    width: 45px;\n    height: 45px;\n    background: #1a1a1a;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.emoji {\n    font-size: 24px;\n}\n\n.tick-mark {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: #00e1b4;\n    color: #000;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n}\n\n/*  */\n\n.persona-top-bar {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.clear-btn {\n    background: transparent;\n    color: #00e6b0;\n    border: none;\n    cursor: pointer;\n}\n\n.add-custom-btn {\n    background: #0a7b5f;\n    padding: 8px 14px;\n    border-radius: 6px;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n}\n\n.row-grid {\n    display: flex;\n    gap: 18px;\n    margin-bottom: 20px;\n}\n\n.persona-card {\n    width: 260px;\n    background: #111;\n    padding: 18px;\n    border-radius: 12px;\n    border: 1px solid #222;\n    cursor: pointer;\n    position: relative;\n}\n\n.persona-card:hover {\n    border-color: #00e6b0;\n}\n\n.selected {\n    border-color: #00e6b0;\n    background: #082b24;\n}\n\n.tick {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: #00e6b0;\n    width: 22px;\n    height: 22px;\n    color: black;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.icon-box {\n    width: 45px;\n    height: 45px;\n    background: #1c1c1c;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.more-box {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.error-text {\n    color: red;\n    margin-top: -10px;\n    margin-bottom: 15px;\n}\n\n.submit-btn {\n    background: #0f9f75;\n    padding: 12px 22px;\n    border-radius: 8px;\n    color: white;\n    border: none;\n    margin-top: 14px;\n}\n\n.sidebar-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0,0,0,0.6);\n    display: flex;\n    justify-content: flex-end;\n}\n\n.sidebar-panel {\n    width: 400px;\n    background: #111;\n    height: 100%;\n    padding: 20px;\n    overflow-y: auto;\n}\n\n.sidebar-card {\n    background: #1a1a1a;\n    border: 1px solid #222;\n    padding: 12px;\n    border-radius: 10px;\n    margin-bottom: 12px;\n    display: flex;\n    align-items: center;\n}\n\n.sidebar-selected {\n    border-color: #00e6b0;\n    background: #083329;\n}\n\n.side-tick {\n    background: #00e6b0;\n    color: black;\n    padding: 4px 8px;\n    border-radius: 50%;\n    margin-left: auto;\n}\n\n\n/* Sidebar Header */\n.sidebar-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #222;\n    margin-bottom: 15px;\n}\n\n.sidebar-header .left-section h3 {\n    font-size: 20px;\n    margin: 0;\n    color: #fff;\n    font-weight: 600;\n}\n\n.sub-text {\n    margin: 0;\n    font-size: 12px;\n    color: #aaaaaa;\n}\n\n/* Right buttons container */\n.right-section {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n/* Add Persona Button */\n.add-btn {\n    background: #0f9f75;\n    color: white;\n    padding: 8px 14px;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    font-size: 13px;\n}\n\n.add-btn:hover {\n    background: #0c7f5c;\n}\n\n/* Clean Close Button */\n.close-btn {\n    background: #1b1b1b;\n    border: 1px solid #333;\n    color: #fff;\n    font-size: 14px;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.close-btn:hover {\n    background: #333;\n}\n\n.jc-create-wrapper {\n    position: relative;\n    display: inline-block;\n    z-index: 999999;\n}\n\n/* Button */\n.jc-create-btn {\n    background-color: #0066ff;\n    color: #fff;\n    border: none;\n    padding: 10px 18px;\n    border-radius: 6px;\n}\n/* ///////////////// */\n\n/* MAIN WRAPPER */\n.consent-box-wrapper {\n    color: #fff;\n    font-family: Inter, sans-serif;\n}\n\n/* TOP CARD */\n.consent-top-card {\n    background: #101823;\n    border: 1px solid #243043;\n    padding: 18px;\n    border-radius: 10px;\n}\n\n/* CONSENT COUNT BOXES */\n.consent-count-box {\n    padding: 10px 18px;\n    border-radius: 10px;\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.jc-create-btn:hover {\n    background-color: #0050d1;\n}\n\n/* Dropdown */\n.jc-dropdown-box {\n    position: absolute;\n    /* top: 8; */\n    right: 0;\n    width: 190px;\n    /* background: #fff; */\n    border-radius: 8px;\n    /* box-shadow: 0px 4px 20px rgba(0, 0, 0, 30); */\n    padding: 8px 0;\n    z-index: 999999 !important;\n    animation: jcFadeIn 0.15s ease-in-out;\n    margin-right: 5px;\n    margin-top: 5px;\n    border: 1px solid #474849;\n}\n\n/* Items */\n.jc-dropdown-item {\n    padding: 10px 15px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: 0.15s;\n    border-radius: 7px;\n}\n\n.jc-dropdown-item:hover {\n    background: #eef2ff;\n    color: #000;\n}\n\n\n/* Fade Animation */\n/* @keyframes jcFadeIn {\n    from { opacity: 0; transform: translateY(-5px); }\n    to { opacity: 1; transform: translateY(0); }\n    gap: 6px;\n} */\n\n/* With Consent */\n.consent-green {\n    background: #0e3b2e;\n    color: #2fe79c;\n    border: 1px solid #2fe79c55;\n}\n\n/* Pending Consent */\n.consent-yellow {\n    background: #3e361f;\n    color: #ffcf43;\n    border: 1px solid #ffcf4355;\n}\n\n/* WARNING BOX */\n.consent-warning-box {\n    background: #2d2619;\n    border: 1px solid #594a2f;\n    padding: 14px;\n    border-radius: 10px;\n    color: #ffd87b;\n    font-size: 14px;\n}\n\n#CreateAgentDropdown {\n    background-color: #0d0f1c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
